import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function ProductDetails(props) {
  return (
    <div>
      <p>
        Designed to help give loved ones a lifetime of protection at an economical monthly rate that will never increase. This product is a whole life insurance
        policy, meaning that it builds cash value. In addition, this premium will never increase for any reason. It's that simple.
      </p>

      <p>
        <strong>For Individuals Seeking the Following:</strong>
      </p>
      <ul>
        <li>Don't want to hassle with medical exams</li>
        <li>The ability to buy online</li>
        <li>Coverage for income replacement in the event of disability</li>
      </ul>

      <p>
        <strong>Product Information</strong>
      </p>
      <ul>
        <li>Ages 18 to 65</li>
        <li>Face Amounts up to the higher of your income or $100,000</li>
      </ul>

      <p>
        <strong>Additional product features:</strong>
      </p>
      <ul>
        <li>Covers both manual and non-manual jobs.</li>
      </ul>
      <div className="product-information">
        <Button
          variant="text"
          color="secondary"
          onClick={() => props.setProductInfoDialogOpen(true)}
        >
          View detailed product information
        </Button>
      </div>

    </div>
  );
}
ProductDetails.propTypes = {
  setProductInfoDialogOpen: PropTypes.func.isRequired,
};
